import { create } from "zustand";
import requestAuthentication from "integrations/authentication";
import HostConfig from "integrations/host/HostConfig";
import useStorePlayer from "./useStorePlayer";

function guard(action: () => void): void {
    const hasSavedAccount = useStorePlayer.getState().player?.hasSavedAccount;

    if(!hasSavedAccount) {
        void requestAuthentication();

        return;
    }

    if(HostConfig.host === "crazygames") {
        return;
    }

    action();
}

type AccountTab = "profile" | "customize";

type StateStoreUserPanel = {
    isOpen: boolean;
    activeAccountTab: AccountTab;
};

type StoreUserPanelActions = {
    open: (tab?: AccountTab) => void;
    close: () => void;
    setActiveAccountTab: (tab: AccountTab) => void;
};

const useStoreUserPanel = create<StateStoreUserPanel & StoreUserPanelActions>((set) => ({
    isOpen: false,
    activeAccountTab: "profile",

    open: (tab = "profile") => guard(() => set({ isOpen: true, activeAccountTab: tab })),
    close: () => set({ isOpen: false }),
    setActiveAccountTab: (tab) => set({ activeAccountTab: tab }),
}));

export default useStoreUserPanel;
